var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSettingCardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.28 12.5301L14.28 19.5301C14.134 19.6761 13.942 19.75 13.75 19.75C13.558 19.75 13.366 19.6771 13.22 19.5301C12.927 19.2371 12.927 18.762 13.22 18.469L18.94 12.749H2.75C2.336 12.749 2 12.413 2 11.999C2 11.585 2.336 11.249 2.75 11.249H18.939L13.219 5.52902C12.926 5.23602 12.926 4.76104 13.219 4.46804C13.512 4.17504 13.987 4.17504 14.28 4.46804L21.28 11.468C21.573 11.763 21.573 12.2371 21.28 12.5301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingCardArrow);
export default __webpack_public_path__ + "static/media/icon-setting-card-arrow.15b90a54d8f23046e54e39e7e3e7cffb.svg";
export { ForwardRef as ReactComponent };